import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ark-lib-html-block',
  templateUrl: './html-block.component.html',
  styleUrls: ['./html-block.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class HtmlBlockComponent implements OnInit {
  @Input() html: any;
  constructor() {}

  ngOnInit() {}
}
